import { ABU } from "./config";

export const carImages = Array(6)
  .fill(null)
  .map((_, i) => `${ABU}scene/car/car_${i}.jpg`);
export const roomImages = Array(6)
  .fill(null)
  .map((_, i) => `${ABU}scene/room/room0${i}.jpg`);

export const workImages = Array(6)
  .fill(null)
  .map((_, i) => `${ABU}scene/job/work_${i}.jpg`);
